import { Autocomplete, Stack, TextField } from "@mui/material";
import React from "react";
import { documentTypeOptions, renderDocumentTypeOption, languageOptions, renderComBrandOption, comBrandOptions } from "../_Utils/AppDocuCommon";

/**
 * DocumentDialogForm - Form comune per AddDocumentDialog e EditDocumentDialog
 * Props:
 *   itemData: oggetto dati documento
 *   onChange: funzione (nuovoItemData) => void
 *   disabled: boolean (opzionale)
 */
export default function DocumentDialogForm({ itemData, onChange, disabled, hideOriginalFilename }) {
  return (
    <Stack spacing={2}>
      {!hideOriginalFilename && (
        <TextField fullWidth label="File Name" value={itemData.original_filename || ''} onChange={e => onChange({ ...itemData, original_filename: e.target.value })} disabled={disabled} />
      )}
      <TextField fullWidth label="Name" value={itemData.name || ''} onChange={e => onChange({ ...itemData, name: e.target.value })} disabled={disabled} />
      <Autocomplete
        freeSolo
        fullWidth
        options={comBrandOptions.map(opt => opt.name)}
        value={itemData.com_brand || ''}
        onChange={(_, newValue) => onChange({ ...itemData, com_brand: newValue || '' })}
        onInputChange={(_, newInputValue) => onChange({ ...itemData, com_brand: newInputValue })}
        renderOption={renderComBrandOption}
        renderInput={(params) => <TextField {...params} label="Com Brand" disabled={disabled} />}
        disableClearable
        autoHighlight
      />
      <Autocomplete
        fullWidth
        options={documentTypeOptions}
        getOptionLabel={opt => opt.label}
        value={documentTypeOptions.find(opt => opt.name === (itemData.document_type || '')) || null}
        onChange={(_, newValue) => onChange({ ...itemData, document_type: newValue ? newValue.name : '' })}
        renderOption={renderDocumentTypeOption}
        renderInput={(params) => <TextField {...params} label="Type" disabled={disabled} />}
        isOptionEqualToValue={(option, value) => option.name === value.name}
        disableClearable
        autoHighlight
      />
      <TextField
        fullWidth
        label="Description"
        value={itemData.description || ''}
        onChange={e => onChange({ ...itemData, description: e.target.value })}
        multiline
        minRows={3}
        disabled={disabled}
      />
      <Autocomplete
        freeSolo
        fullWidth
        options={languageOptions}
        value={itemData.language || ''}
        onChange={(_, newValue) => onChange({ ...itemData, language: newValue || '' })}
        onInputChange={(_, newInputValue) => onChange({ ...itemData, language: newInputValue })}
        renderInput={(params) => <TextField {...params} label="Language" disabled={disabled} />}
        disableClearable
        autoHighlight
      />
    </Stack>
  );
}
